const slideBrandList = document.getElementById('slideBrandList');

let splideBrandList = new Splide(slideBrandList, {
  type: 'slide',
  perPage: 6,
  perMove: 1,
  speed: 500,
  gap: '24px',
  pagination: false,
  arrows: true,
  breakpoints: {
    840: {
      perPage: 4,
      focus: 0,
      gap: '12px',
    },
    767: {
      perPage: 3,
      gap: '8px',
    },
  },
});

let lastArrowsState = null;

function updateArrows(splide) {
  const perPage = splide.options.perPage;
  const slideCount = splide.length;
  const shouldShowArrows = slideCount > perPage;

  if (lastArrowsState === shouldShowArrows) return;

  lastArrowsState = shouldShowArrows;
  splide.options = {arrows: shouldShowArrows};
}

splideBrandList.on('mounted resized', () => {
  updateArrows(splideBrandList);
});

splideBrandList.mount();
